var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrelloMark = function SvgTrelloMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "trello-19f8a52c7c7f889a6b86e3bb8ee63534e1e5fa25086744687f076af0e5b33706")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28,0H4C1.791,0,0,1.791,0,4v24c0,2.209,1.791,4,4,4h24c2.209,0,4-1.791,4-4V4C32,1.791,30.209,0,28,0z  M13.92,24.24c0,1.061-0.859,1.92-1.92,1.92H6.08c-1.061,0-1.92-0.859-1.92-1.92V6.08c0-1.06,0.86-1.92,1.92-1.92H12 c1.061,0,1.92,0.859,1.92,1.92V24.24z M27.84,16.24c0,1.061-0.859,1.92-1.92,1.92H20c-1.061,0-1.92-0.859-1.92-1.92V6.08 c0-1.06,0.859-1.92,1.92-1.92h5.92c1.061,0,1.92,0.859,1.92,1.92V16.24z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrelloMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trello-mark.1f32121f.svg";
export { ForwardRef as ReactComponent };